import { useTranslation } from 'react-i18next';
import { FormInput } from 'ui/FormComponents';
import './CaseTitle.scss';
import { EditOutlined } from '@mui/icons-material';

export function CaseTitle() {
  const { t } = useTranslation();

  return (
    <FormInput
      name="name"
      classname="case-title"
      variant="borderless"
      placeHolderText={t('case:placeholders.caseTitle')}
      rules={{
        minLength: 2,
        required: t('components:authorized_users.modal.required_field'),
      }}
      isRequired
      icon={<EditOutlined />}
    />
  );
}
